// extracted by mini-css-extract-plugin
export default {"header-wrap":"index_header-wrap__LG9lX"};